// extracted by mini-css-extract-plugin
module.exports = {"theme":"rgba(28,153,226,.7529411765)","green":"#38ca73"};